export default __webpack_public_path__ + "static/media/top-tier-solar-bg.b6559ba2.jpeg";